<template>
<!-- 没有做迭代 当时有报错 -->
  <!-- <a class="menu" @click="$emit('click', $event)">
    <slot></slot>
  </a> -->
  <el-menu class="el-menu-saas" refs="menu" :default-active="menuActive" :unique-opened="true">
    <template v-for="(item, index) in list">
      <template v-if="item.subMenuList && item.subMenuList.length > 0">
        <el-submenu :key="index" :index="index+1+''" v-show="!item.noshow"  class="saas-menu-onetitle">
            <template slot="title">
              <!--<i class="el-icon-home"><img class="img-svg" src="//img1.jianyewy.com/5ba9bb415718ad899a6de3fbd75ee01f.svg" /></i>-->
              <!--<i class="el-icon-home"><iframe class="iframe-svg" src="//img1.jianyewy.com/5ba9bb415718ad899a6de3fbd75ee01f.svg"></iframe></i>-->
              <i class="el-icon-home" :style="'background-image: url('+item.icon+')'"></i>
              <span slot="title">{{ item.name }}</span>
            </template>
            <el-menu-item-group>
              <!-- <el-menu-item v-for="(ite,idx) of item.value" index="(index+1)+'-'+(id+1)" :key="idx">{{ ite.name }}</el-menu-item> -->
              <template v-for="(ite,idx) of item.subMenuList">
                <template v-if="ite.subMenuList && ite.subMenuList.length > 0">
                  <!-- <menu-ls :list="ite.value" :key="idx"></menu-ls>
                  -->
                  <el-submenu :key="idx" :index="(index+1)+'-'+(idx+1)" v-show="!item.noshow || !ite.noshow">
                    <template slot="title">
                      <span slot="title" style="padding-left: 6px;">{{ ite.name }}</span>
                    </template>
                    <el-menu-item-group>
                      <template v-for="(it,id) of ite.subMenuList">
                        <el-menu-item :index="(index+1)+'-'+(idx+1)+'-'+(id+1)" :key="id" v-show="!item.noshow || !ite.noshow || !it.noshow" @click="menuClick(it,(index+1)+'-'+(idx+1)+'-'+(id+1))" style="padding-left:60px;"><span>{{ it.name }}</span></el-menu-item>
                      </template>
                    </el-menu-item-group>
                  </el-submenu>
                </template>
                <template v-else-if="!ite.subMenuList || ite.subMenuList.length==0">
                  <el-menu-item class="menu-two-content" :index="(index+1)+'-'+(idx+1)" :key="idx" v-show="!item.noshow || !ite.noshow" @click="menuClick(ite,(index+1)+'-'+(idx+1))"><span>{{ ite.name }}</span></el-menu-item>
                </template>            
              </template>   
            </el-menu-item-group>  
        </el-submenu> 
      </template>
      <template v-else-if="!item.subMenuList || item.subMenuList.length==0">
        <el-menu-item class="saas-menu-one menu-one-content" :index="index+1+''" style="padding-left: 0px;font-size: 14px;" :key="index" v-show="!item.noshow" @click="menuClick(item,index+1+'')"><i class="el-icon-home" :style="'background-image: url('+item.icon+')'"></i><span slot="title">{{ item.name }}</span></el-menu-item>
      </template>
    </template>
  </el-menu>  
</template>

<script>
import Axios from "axios";
import { mapMutations,mapActions } from 'vuex';
import { createNamespacedHelpers } from 'vuex';
// const { mapActions } = createNamespacedHelpers('account/login');
export default {
  name: 'MenuLs',
  model: {
    prop: 'tabValue',
    event: 'change'
  },
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tabslist: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tabValue: {
      type: String,
      default: ''
    },
    menuActive: { type: String, default: '' }
  },
  data() {
    return { tab: this.index };
  },
  methods: {
    ...mapMutations(['setFrontUrl']),
    ...mapActions(['checkAccount']),
    active(index) {
      if (this.force || this.tab !== index) {
        this.tab = index;
        this.$emit('click', index);
      }
    },
    async menuClick(item, index) {
      // 验证登录状态--
      let result = await this.checkAccount({ mchId: this.$store.state.user.tenementId });
      if ( result.code == 403 ) {
        return;
      }
      if (!item.frontUrl) return;
      /** 打开新tab的菜单处理 start */ 
      // item.frontUrl = '/account/rqhome?opennewwindow'
      let arr = item.frontUrl.split('?');
      if( arr.length>1&& arr[1].match('opennewwindow')) {
        window.open( item.frontUrl,'_blank');
        return;
      }
      /** end */ 
      /** 打开新前介云的菜单处理
        * url要求：参数带openqianjieyun&,且最后一项是token带=，如：
        * 'http://devtest10.buildingqm.com/zj_sso/v2/papi/sso/client/verify/?openqianjieyun&group_code=qianding&group_id=104951&uuid='
       start */ 
      if( arr.length>1&& arr[1].indexOf('openqianjieyun')!=-1) {
        Axios.post('/account/ajax/getToken', {}).then(
          res => {
            if (res.code == 200 && res.data) {
              var uuid = res.data;
              var url = item.frontUrl.split('openqianjieyun&')[0]+item.frontUrl.split('openqianjieyun&')[1]+ uuid;
              window.open( url,'_blank');
              return;
            } else {
              this.$message({
                message: "获取token失败！",
                type: 'warning'
              });
            }
          },
          rej => rej
        );
        return;
      }
      /** end */ 
      sessionStorage.setItem('menuActive', index);
      // 
      let tabInd = (sessionStorage.getItem('curMenuIndex')?(sessionStorage.getItem('curMenuIndex')==-1?'0':sessionStorage.getItem('curMenuIndex')):'0') + '-' + index;
      let flag = false;
      let newUrl = '';
      for (let i = 0; i < this.tabslist.length; i++) {
        if (this.tabslist[i].name == item.id) {
          flag = true;
          newUrl = this.tabslist[i].url;//item.frontUrl;//this.tabslist[i].url; 20190117菜单点击还是原链接
          break;
        }
      }
      let isSkyLine = false;
      let tabName = item.id;
      if (item.frontUrl.match(/b\.jianyewy\.com/) || !item.frontUrl.match(/\/\//)) {
        isSkyLine = false;

        if (flag) {
          // this.tabValue = tabInd;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', tabName);
          this.$emit('change', tabName);
          this.$router.push(newUrl);
        } else {
          // include 
          let arr = item.frontUrl.split('/');
          let routeName = '';
          if(arr && arr.length>0){
            routeName = arr[arr.length-1];
          }
          this.tabslist.push({
            title: item.name,
            name: tabName,
            url: item.frontUrl,
            isSkyLine: isSkyLine,
            routeName: routeName,
            tabId: tabInd
          });
          // this.tabValue = tabInd;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', tabName);
          this.$emit('change', tabName);
          this.$router.push(item.frontUrl);
        }

        // this.$router.push(item.frontUrl);
      } else {
        document.domain = 'jianyewy.com';
        // 设置同域
        let urlHeader = location.protocol;
        let frontUrl = item.frontUrl;
        let urls = frontUrl.split("/");
        if (urls && urls.length>0 && urls[0]!=urlHeader) {
          frontUrl = frontUrl.replace(urls[0], urlHeader);
        }
        this.setFrontUrl(frontUrl);
        isSkyLine = true;


        if (flag) {
          // this.tabValue = tabInd;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', tabName);
          this.$emit('change', tabName);

          this.$router.push('/skyline');
        } else {
          this.tabslist.push({
            title: item.name,
            name: tabName,
            url: frontUrl,
            isSkyLine: isSkyLine,
            tabId: tabInd
          });
          // this.tabValue = tabInd;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', tabName);
          this.$emit('change', tabName);

          this.$router.push('/skyline');
          // document.getElementById(tabName).contentWindow.location.reload(true);
        }
        
        // this.$router.push('/skyline');
      }


    }
  }
};
</script>